{
    "webshop_offer_voucher_correctCode": "Введен правильный код",
    "webShop_howToFindId_desc": "Ты можешь найти и скопировать свой личный идентификатор в своем профиле игрока.",
    "webShop_howToFindId_link": "Где я могу найти свой личный идентификатор?",
    "webshop_offer_voucher_codeIsIncorrect": "Неправильный код",
    "webshop_offer_voucher_enterYourCode": "Введи свой личный идентификатор",
    "webShop_unexpectedError_desc": "Произошла непредвиденная ошибка; повтори попытку чуть позже.",
    "webShop_accountBanned_desc": "Учетная запись заблокирована!",
    "webshop_confirm": "OK",
    "webshop_termsConditions_1": "Пользовательское соглашение",
    "webshop_purchase_privacyPolicy": "Политика конфиденциальности",
    "webshop_legal_1": "Юридическая информация",
    "webshop_support_1": "Поддержка",
    "mbs_access_welcome_desc": "Добро пожаловать, {0}!",
    "btn_login": "Вход",
    "mbs_access_error_sessionExpired_desc": "Время сеанса истекло. Введи свой идентификатор учетной записи вручную."
}
